const campaignModelFields = [
  'title',
  'draft',
  'active',
  'messages',
  'email_addressable',
  'inbox_addressable',
  'sms_addressable',
  'webhook_addressable',
  'broadcast',
  'conversions',
  'event_conditions',
  'category_id',
  'goal_conditions',
  'event_filter',
  'facebook',
  'conditions',
  'content_fetch',
  'content_fetch_sources',
  'encryption',
  'languages_default',
  'languages_list',
  'type',
  'trigger',
  'promotion',
  'promotion_id',
  'promotion_action',
  'promotion_params',
  'promotion_amount',
  'promotion_amount_type',
  'promotion_amount_attribute_title',
  'promotion_amount_metric_title',
  'promotion_amount_property_title',
  'promotion_amount_window',
  'promotion_amount_daterange',
  'promotion_amount_percents',
  'promotion_amount_round',
  'promotion_amount_min',
  'promotion_amount_cap',
  'promotion_duration',
  'ab',
  'ab_cg',
  'ab_cg_size',
  'ab_variants',
  'event',
  'event_title',
  'event_mode',
  'event_delay_time',
  'event_delay_period',
  'event_limit_per_user',
  'event_limit_per_user_scope',
  'event_limit_per_user_period',
  'event_limit_nth_hit',
  'event_limit_nth_hit_scope',
  'event_limit_nth_hit_period',
  'location_limit_per_user',
  'location_limit_per_user_period',
  'location_limit_per_location',
  'location_limit_per_location_period',
  'location_limit_nth_hit',
  'location_limit_nth_hit_period',
  'languages_multi',
  'ios_push',
  'ios_push_production',
  'ios_push_sandbox',
  'ios_push_legacy',
  'android_push',
  'android_push_production',
  'android_push_legacy',
  'web_push',
  'email',
  'sms',
  'inapp',
  'inapp_ios',
  'inapp_android',
  'inbox',
  'onsite',
  'webhook',
  'whatsapp',
  'locations',
  'location_trigger',
  'location_dwell_time',
  'target_applications',
  'target_application_enabled',
  'target_devices',
  'variants',
  'web_push_safari',
  'web_push_chrome',
  'web_push_firefox',
  'send_type',
  'send_date',
  'send_time',
  'status',
  'status_canonical',
  'timezone',
  'retry_type',
  'retry_for',
  'retry_for_period',
  'retry_until',
  'persist_type',
  'persist_for',
  'persist_for_period',
  'persist_until',
  'send_days',
  'send_option',
  'send_interval',
  'send_frequency',
  'start_date',
  'start_time',
  'start_date_time',
  'end_date',
  'end_time',
  'end_date_time',
  'end_date_timezone',
  'prepare_interval_enabled',
  'prepare_interval',
  'optimove_type',
  'automatically_pick_winner',
  'automatically_pick_winner_after_n',
  'automatically_pick_winner_after_period',
  'automatically_pick_winner_sample_channel',
  'automatically_pick_winner_sample_type',
  'automatically_pick_winner_sample_percentage',
  'automatically_pick_winner_schedule_status',
  'seed_list_enabled',
  'throttling',
  'throttling_data',
  'is_campaign_template',
  'campaign_template_last_used',
  'create_time',
  'rolling_segment_id',
  'random_variant_allocation',
  'custom_variant_share',
  'early_cancel_event_title',
  'early_cancel_event_filter',
  'early_cancel_event_conditions',
  'target_authorised_devices',
  'reports',
  'voucher_codes_enabled',
  'voucher_codes_file',
  'consent_preference',
  'consent_preference_name',
  'enter_journey_once_ever',
  'enter_journey_once_at_a_time',
  'qualification',
  'qualification_event_title',
  'qualification_event_filter',
  'qualification_event_conditions',
  'qualification_time',
  'qualification_period',
  'accumulation_conditions',
  'new_mxa',
  'mxa_migration'
]

export { campaignModelFields }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/CampaignModelFields.js